import { memo, useState } from "react";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import Button from "@mui/material/Button";
import PersonBatchRegisterDialog from "./PersonBatchRegisterDialog";

type PersonBatchRegisterTriggerProps = {
  organizationId?: string;
  /** Rótulo visível. Sem jargão técnico. */
  label?: string;
  /** Após Concluir o cadastro em lote. */
  onFinished?: () => void;
};

/**
 * Botão + dialog de cadastro em lote. As telas só passam a organização.
 */
const PersonBatchRegisterTrigger = memo(
  ({
    organizationId,
    label = "Cadastrar clientes",
    onFinished,
  }: PersonBatchRegisterTriggerProps) => {
    const [open, setOpen] = useState(false);

    return (
      <>
        <Button
          variant="outlined"
          size="small"
          startIcon={<UploadFileIcon />}
          onClick={() => setOpen(true)}
          disabled={!organizationId}
          sx={{
            textTransform: "none",
            fontWeight: 600,
            whiteSpace: "nowrap",
            height: 32,
          }}
        >
          {label}
        </Button>
        {open && (
          <PersonBatchRegisterDialog
            open={open}
            onClose={() => setOpen(false)}
            organizationId={organizationId}
            onFinished={onFinished}
          />
        )}
      </>
    );
  },
);

PersonBatchRegisterTrigger.displayName = "PersonBatchRegisterTrigger";

export default PersonBatchRegisterTrigger;
